import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-75149544"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "slider-text bold"
}
const _hoisted_2 = ["checked"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "toggle-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['se-toggle-container', _ctx.variantClass])
  }, [
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("label", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClick())),
      class: "se-toggle"
    }, [
      _createElementVNode("input", {
        checked: 
          this.defaultValue != undefined ? this.defaultValue : this.modelValue
        ,
        type: "checkbox"
      }, null, 8, _hoisted_2),
      _hoisted_3,
      (_ctx.toggleIconText !== '')
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.toggleIconText), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}